import React, { Fragment } from "react";
import { Col } from "antd";
import EventHistory from "./EventHistory";
import ExploreEvents from "./ExploreEvents";
import ExploreEventsAccordian from "./Accordians/ExploreEventsAccordian";

function EventBar({ exploreevents, eventHistoryLInk, current, hideEventHistory = false, big, md }) {
  return (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={big ? 24 : md ? 9 : 6}
      xl={big ? 24 : 6}
      order={window.innerWidth < 768 ? 2 : 3}>
      {exploreevents ? (
        <Fragment>
          <div className="d-md-block d-none">
            <ExploreEventsAccordian />
          </div>
          <div className="d-md-none">
            <ExploreEvents />
          </div>
        </Fragment>
      ) : null}
      {hideEventHistory ? null : <EventHistory linkTo={eventHistoryLInk} current={current} />}
    </Col>
  );
}

export default EventBar;
